import { useContext } from "react";
import AuthContext from "../context/AuthProviderDashboard";

const useAuth = () => {
    return useContext(AuthContext);
}

export default useAuth;